import ChartFetch from "@/components/HomeCharts/ChartFetch";
import DashboardImage from "@/components/LayoutCharts/DashboardImage";
import DialFetch from "@/components/LayoutCharts/DialFetch";
import LayoutAlarmNotification from "@/components/LayoutCharts/LayoutAlarmNotification";
import LayoutTextBox from "@/components/LayoutCharts/LayoutTextBox";
import TableChart from "@/components/LayoutCharts/TableChart";
import PropTypes from "prop-types";
import React from "react";

function DashboardPreview({ item }) {
  const preview = {
    // chart fetch
    bar: <ChartFetch data={item} type={item.component} />,
    line: <ChartFetch data={item} type={item.component} />,
    comboBar: <ChartFetch data={item} type={item.component} />,
    pie: <ChartFetch data={item} type={item.component} />,

    // dial fetch
    dial: <DialFetch data={item} type={item.component} />,
    splitCounter: <DialFetch data={item} type={item.component} />,
    tank: <DialFetch data={item} type={item.component} />,
    dynamicBox: <DialFetch data={item} type={item.component} />,
    loadSummary: <DialFetch data={item} type={item.component} />,
    thermometer: <DialFetch data={item} type={item.component} />,
    counter: <DialFetch data={item} type={item.component} />,

    // no extra api
    html: <LayoutTextBox data={item} />,
    textBox: <LayoutTextBox data={item} />,
    image: <DashboardImage data={item} />,
    alarmNotification: <LayoutAlarmNotification data={item} />,
    
    // other
    table: <TableChart {...{ data: item }} />,

  };
  return (
    <>
      {/* {item?.component} */}
      <>
        {item?.component === "iframe" ? (
          <iframe title="Dashboard" src={item?.iframe} style={{ width: "100%", height: "60vh" }}>
            Iframe does not supported
          </iframe>
        ) : (
          preview[item?.component] || "Not Supported"
        )}
      </>
    </>
  );
}

export default React.memo(DashboardPreview);

DashboardPreview.propTypes = {
  item: PropTypes.object,
  iframe: PropTypes.string,
};
